export const LOAD_TRANSLATIONS = 'LOAD_TRANSLATIONS';
export const SET_RESELLER_FOR_TRANSLATIONS = 'SET_RESELLER_FOR_TRANSLATIONS';
export const SET_PRODUCT_FOR_TRANSLATIONS = 'SET_PRODUCT_FOR_TRANSLATIONS';
export const SET_TRANSLATION_PAGINATION = 'SET_TRANSLATION_PAGINATION';
export const EDIT_TRANSLATIONS = 'EDIT_TRANSLATIONS';
export const SET_EMPTY_PRODUCTS_FROM_TRANSLATIONS = 'SET_EMPTY_PRODUCTS_FROM_TRANSLATIONS';
export const SET_EMPTY_EDITABLE_TRANSLATIONS = 'SET_EMPTY_EDITABLE_TRANSLATIONS';
export const LOAD_EDITABLE_TRANSLATION = 'LOAD_EDITABLE_TRANSLATION';
export const ADD_NEW_TRANSLATION = 'ADD_NEW_TRANSLATION';
export const RESET_TRANSLATION_PRODUCT_PAGINATION_LIST = 'RESET_TRANSLATION_PRODUCT_PAGINATION_LIST';
export const SET_TRANSLATION_FILTER = 'SET_TRANSLATION_FILTER';
export const SET_TRANSLATION_SORT = 'SET_TRANSLATION_SORT';
export const RESET_TRANSLATION_FILTERS = 'RESET_TRANSLATION_FILTERS';
export const SET_TRANSLATION_TAG_POPUP = 'SET_TRANSLATION_TAG_POPUP';
export const ADD_TRANSLATION_TAG = 'ADD_TRANSLATION_TAG';
export const EDIT_TRANSLATION_TAG = 'EDIT_TRANSLATION_TAG';
export const SET_SOURCE = 'SET_SOURCE';
